// extracted by mini-css-extract-plugin
module.exports = {"tagsList":"TagsList_tagsList__hAiej"};